import {Box, Tab, Theme} from "@material-ui/core";
import styled, {} from "styled-components";
import React from "react";

type P = {
  theme: Theme
}

export const FiltersRow = styled(Box)`
  display: flex;
  flex-direction: row;
  & > :not(:last-child) {
    padding-right: ${(p: P) => p.theme.spacing(1)}px;
  }
`

export const FiltersCol = styled(Box)`
  display: flex;
  flex-direction: column;
  & > :not(:last-child) {
    padding-top: ${(p: P) => p.theme.spacing(1)}px;
  }
`

interface LinkTabProps {
  label?: string;
  href?: string;
  value?: string;
}

export function LinkTab(props: LinkTabProps) {
  return (
    <Tab
      component="a"
      {...props}
    />
  );
}
